import './styles/ModalHeader.css'
import errorIcon from './assets/modal-error.svg';
import successIcon from './assets/modal-success.svg';
import warningIcon from './assets/modal-warrning.svg';
import PropTypes from 'prop-types';
import React from "react";

export default function ModalHeader({ title, type, setIsOpened }) {

    function getIconUrl() {
        switch (type) {
            case 'success':
                return successIcon;
            case 'error':
                return errorIcon;
            case 'warning':
                return warningIcon;
            default:
                return errorIcon;
        }
    }

    return (<>
        <div className="modal__header">
            <div className="left-part">
                { type !== "default" && <img src={getIconUrl()} alt="error"/> }
                <h1 className="payment-title">{title}</h1>
            </div>
            <svg
                className="payment-modal__close"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => setIsOpened(false)}
            >
                <path d="M6 6L22.9706 22.9706" stroke="#032320" strokeWidth="2" strokeLinecap="round"/>
                <path d="M6 23L22.9706 6.02944" stroke="#032320" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        </div>
        <div className="divider"></div>
    </>)
}

ModalHeader.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['success', 'error', 'warning', 'default']).isRequired,
    setIsOpened: PropTypes.func.isRequired,
}